import {FC} from "react";
import {useOldCommonOrgEntity} from "../../context";
import {TabRow} from "../../../tab-content";
import {EntityStatusBar} from "../../badges";
import {EntityStatus} from "@common-core/coat-operational-hierarchy-appsync-model";

export const OldCommonOrgDealerStatusBar: FC = () => {
  const {entity} = useOldCommonOrgEntity();

  return (
    <TabRow name={"dealer-status-bar"}>
      <EntityStatusBar
        id={entity.id}
        statuses={
          entity.statuses?.filter(
            status => status !== EntityStatus.PROTECTED
          ) || []
        }
        compact={false}
      />
    </TabRow>
  );
};
